export default "__VITE_ASSET__326420de__"